import React, { Fragment, useEffect } from 'react';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs';
import DefaultContain from '../../../Component/DashBoard/Default/index';

const Default = () => {
  useEffect(() => {
      window.scrollTo(0, 0);
  }, []);
      
  return (
    <Fragment>
      <Breadcrumbs parent="Dashboards" title="Qeza Care" />
      <DefaultContain />
    </Fragment>
  );
};
export default Default;